// Docs
// https://marmelab.com/react-admin/Show.html#actions
// https://github.com/marmelab/react-admin/blob/master/docs/Actions.md
// https://reactjs.org/docs/conditional-rendering.html

import React from 'react';
import { Filter } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import CustomCreateButton from './CustomCreateButton';

export const ListHeaderWithFiltersStyles = {
  wrapper: {
    width: '100%',
  },
  form: {
    display: 'inline-flex',
    marginBottom: '-3px',
  },
  filters: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    height: '55px',
  },
  header: {
    fontSize: '24px',
    lineHeight: '30px',
    marginRight: 'auto',
  },
  subtitle: {
    fontSize: '12px',
    lineHeight: '14px',
    marginTop: '13px',
    marginBottom: '24px',
    color: '#8E8F8E',
  },
  buttonWrapper: {
    marginBottom: '3px',
  }
};

export const ListHeaderWithFilters = ({ classes, createBtnLabel, createBtnLabelSmall, title, subtitle, children, customUrl, ...props }) => (
  <div className={classes.wrapper}>
    <div className={classes.filters}>
      <Typography variant='h5' className={classes.header}>
        {title}
      </Typography>
      <Filter {...props} className={classes.form}>
        {children}
      </Filter>
      <div className={classes.buttonWrapper}>
        <CustomCreateButton
          customUrl={customUrl}
          basePath={props.basePath}
          label={createBtnLabel}
          labelSmall={createBtnLabelSmall}
        />
      </div>
    </div>
    <Typography variant='body2' className={classes.subtitle}>
      {subtitle}
    </Typography>
  </div>
);

export default withStyles(ListHeaderWithFiltersStyles)(ListHeaderWithFilters)
